import {
    AddPropertyIcon,
    LogoutIcon,
    PropertiesIcon
} from "../../icons";
import {
    Box,
    Divider,
    List
} from "@mui/material";
import {
    eligibilityCheckErrorAtom,
    isLogoutWarningPromptOpenAtom,
    showUserOnboardingWizardAtom
} from "../../../lib/sidebar/SidebarRecoilStates";
import {
    useRecoilValue,
    useSetRecoilState
} from "recoil";

import ContactIcon from "../../icons/ContactIcon";
import { DataSyncStatusIndicatorListItem } from "./DataSyncStatusIndicatorListItem";
import { DrawerListItemButton } from "../DrawerListItemButton";
import { useTeamManagement } from "../../../pages/teamManagement/useTeamManagement";

type PropertyManagerDrawerListItemsProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export const PropertyManagerDrawerListItems = (props: PropertyManagerDrawerListItemsProps) => {
    const { isOpen, setIsOpen } = props;
    const setLogoutWarningPromptOpen = useSetRecoilState(isLogoutWarningPromptOpenAtom);
    const { isAccountOwner } = useTeamManagement();

    const eligibilityCheckError = useRecoilValue(eligibilityCheckErrorAtom);
    const showUserOnboardingWizard = useRecoilValue(showUserOnboardingWizardAtom);
    const canCreateProperty = isAccountOwner;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%"
            }}
        >
            <Box>
                <List
                    disablePadding
                    sx={
                        showUserOnboardingWizard || eligibilityCheckError ? {
                            display: "none"
                        } : {
                            display: "block"
                        }
                    }
                >
                    <Divider />
                    <DrawerListItemButton
                        key="view-properties"
                        icon={<PropertiesIcon />}
                        title="View Properties"
                        isOpen={isOpen}
                        linkTo="/properties"
                        onClick={() => setIsOpen(false)}
                    />
                    <Divider />
                    {canCreateProperty && (
                        <>
                            <DrawerListItemButton
                                key="add-properties"
                                icon={<AddPropertyIcon />}
                                title="Add Property"
                                isOpen={isOpen}
                                linkTo="/properties/create"
                                onClick={() => setIsOpen(false)}
                            />
                            <Divider />
                        </>
                    )}
                    <DrawerListItemButton
                        key="contact"
                        icon={<ContactIcon />}
                        title="Contacts"
                        isOpen={isOpen}
                        linkTo="/contacts"
                        onClick={() => setIsOpen(false)}
                    />
                </List>
            </Box>
            <Box>
                {isOpen && (
                    <>
                        <DrawerListItemButton
                            key="logout"
                            icon={<LogoutIcon />}
                            title="Log Out"
                            isOpen={isOpen}
                            onClick={() => setLogoutWarningPromptOpen(true)}
                        />
                        <Divider />
                    </>
                )}
                <DataSyncStatusIndicatorListItem isOpen={isOpen} />
            </Box>
        </Box>
    );
};